import * as React from 'react';

export const pureComponent = <T>(
  component: React.FC<T>,
): React.MemoExoticComponent<React.FC<T>> => {
  return React.memo(
    component,
    (prevProps, nextProps) =>
      !Object.keys(nextProps).find((property) => {
        if (property === 'siblings') {
          return false;
        }
        const prevProp = (prevProps as Record<string, unknown>)[property];
        const nextProp = (nextProps as Record<string, unknown>)[property];
        if (prevProp !== nextProp) {
          return true;
        }
        return false;
      }),
  );
};
